/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';

import { registerLocaleData } from '@angular/common';
// import localeHe from '@angular/common/locales/he';

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

// registerLocaleData(localeHe);

// --- trying to fixing the language issue - NOT NEEDED! ---
import localeHe from '@angular/common/locales/he';
import localeEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';

Sentry.init({
  dsn: "https://a4e83bfefcc587f739aff681a56a5628@o4504164014555136.ingest.us.sentry.io/4508732359114752",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err =>
    console.error(err)
  );

if (localStorage.getItem('language') === 'en') {
  registerLocaleData(localeEn);
} else if (localStorage.getItem('language') === 'ar') {
  registerLocaleData(localeAr);
} else {
  registerLocaleData(localeHe);
}
// console.log("selected---Lang---uage: 4" + localStorage.getItem('language'))

